import consumer from "./consumer"

consumer.subscriptions.create("ReplyNotificationsChannel", {
  connected(e) {
    // Called when the subscription is ready for use on the server
    // console.log('ReplyNotificationsChannel connected', e);
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
    // console.log('ReplyNotificationsChannel disconnected');
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
    // console.log('ReplyNotificationsChannel received:', data);
    // App.messages.updated(data)
  }
});
